export default __webpack_public_path__ + "static/media/search.06300a9c.svg";